import { format } from 'date-fns';

export default function displayPeriodDay(startDate?: Date, endDate?: Date) {
  if (!startDate || !endDate) return '';
  return `${format(new Date(startDate), 'dd/MM/yyyy')} - ${format(
    new Date(endDate),
    'dd/MM/yyyy'
  )}`;
}
